// extracted by mini-css-extract-plugin
export default {"LoginWrapper":"Login_LoginWrapper__Pp552","Image":"Login_Image__r+vv4"};